/** Default callout card heading when authors have not set a custom title. */
export const REPORT_CALLOUT_DEFAULT_TITLE = 'Callout';

/**
 * Resolves the callout heading for display.
 * @param title - Stored callout title or null for the default.
 * @returns Heading text shown above the callout body.
 */
export const resolveReportCalloutTitle = (
  title: string | null | undefined,
): string => {
  const trimmed = title?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : REPORT_CALLOUT_DEFAULT_TITLE;
};

/**
 * Normalizes inline-edited callout title text for API persistence.
 * @param value - Raw title from a contentEditable blur event.
 * @returns Stored title or null when the default label is used.
 */
export const normalizeReportCalloutTitleForStorage = (
  value: string,
): string | null => {
  const trimmed = value.trim();
  if (
    trimmed === '' ||
    trimmed.toLowerCase() === REPORT_CALLOUT_DEFAULT_TITLE.toLowerCase()
  ) {
    return null;
  }
  return trimmed;
};
